module.exports = "https://static.wanderu.com/static/media/auto-grey.1ffeaf98.svg";